module.exports = __webpack_public_path__ + "img/testpreviewillustration.7862f58d.svg";